import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const NEW_STAGE = "__new";
const TONE = { won: "text-emerald-700", lost: "text-slate-400", open: "text-sky-700" };

// «Stato» cell: the pipeline stages (same data as the Kanban); last option adds a new stage.
export default function StageCell({ stages, value, onChange, disabled, canAdd, testid }) {
  const st = stages.find((s) => s.id === value);
  if (disabled) return <span className={`inline-block px-1.5 text-xs font-medium ${TONE[st?.kind] || "text-slate-400"}`} data-testid={testid}>{st?.name || "—"}</span>;
  return (
    <Select value={value ?? ""} disabled={disabled} onValueChange={onChange}>
      <SelectTrigger className={`h-7 min-w-[120px] border-transparent bg-transparent px-1.5 text-xs font-medium hover:border-slate-200 ${TONE[st?.kind] || "text-slate-400"}`} data-testid={testid}>
        <SelectValue placeholder="Imposta stato" /></SelectTrigger>
      <SelectContent>
        {stages.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}
        {canAdd && <SelectItem value={NEW_STAGE} data-testid={`${testid}-new`}>+ Nuovo stato…</SelectItem>}
      </SelectContent>
    </Select>
  );
}
